import { Sprite } from '@ktag/styleguide/dist/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  hasMore: boolean;
  onLoadMore: () => void;
}

const LoadMore = ({ hasMore, onLoadMore }: Props) => {
  const { t } = useTranslation('jobs');
  if (!hasMore) return null;

  return (
    <div className="loadmore">
      <button type="button" onClick={onLoadMore} className="loadmore__button">
        {t('loadmore')}
        <Sprite id="chevron" className="loadmore__icon" />
      </button>
    </div>
  );
};

export default LoadMore;
